module.exports = __webpack_public_path__ + "img/banner-39.ba77e8e4.jpg";